import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import storage from "../helpers/storage.js";
import { useEffect } from "react";

function RequireAuth({ children, isSignedIn }) {
  let location = useLocation();
  let [searchParams] = useSearchParams();

  useEffect(() => {
    const currentFile = searchParams.get("filename");
    if (currentFile) {
      storage.setFileName(currentFile);
    }
  }, []);

  if (!isSignedIn) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

export default RequireAuth;
